var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangePowered(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368_3522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99631 16.6596C11.6766 16.6596 14.6601 13.6761 14.6601 9.99582C14.6601 6.31551 11.6766 3.33203 7.99631 3.33203C4.316 3.33203 1.33252 6.31551 1.33252 9.99582C1.33252 13.6761 4.316 16.6596 7.99631 16.6596Z",
    stroke: "#E17100",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99658 12.6616V9.99609",
    stroke: "#E17100",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99658 7.33008H8.00325",
    stroke: "#E17100",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_3522"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9931,
    height: 15.9931,
    fill: "white",
    transform: "translate(0 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangePowered);
export default __webpack_public_path__ + "static/media/orange_powered.4b3ad9d38b9fbccc7143fc65cce3184c.svg";
export { ForwardRef as ReactComponent };